/**
 * @generated SignedSource<<ef2d84aeecd7268dfb3e3d4381b97655>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TestCustomMcpServerUrlInput = {
  authType: string;
  credentials?: string | null | undefined;
  url: string;
};
export type CreateMcpServerRouteTestUrlMutation$variables = {
  input: TestCustomMcpServerUrlInput;
};
export type CreateMcpServerRouteTestUrlMutation$data = {
  readonly testCustomMcpServerUrl: {
    readonly error: string | null | undefined;
    readonly success: boolean;
    readonly tools: ReadonlyArray<string>;
  };
};
export type CreateMcpServerRouteTestUrlMutation = {
  response: CreateMcpServerRouteTestUrlMutation$data;
  variables: CreateMcpServerRouteTestUrlMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TestConnectionPayload",
    "kind": "LinkedField",
    "name": "testCustomMcpServerUrl",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tools",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateMcpServerRouteTestUrlMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateMcpServerRouteTestUrlMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2fba71954c04c6d4437b156f3b9a57e6",
    "id": null,
    "metadata": {},
    "name": "CreateMcpServerRouteTestUrlMutation",
    "operationKind": "mutation",
    "text": "mutation CreateMcpServerRouteTestUrlMutation(\n  $input: TestCustomMcpServerUrlInput!\n) {\n  testCustomMcpServerUrl(input: $input) {\n    success\n    tools\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "195050c65234ea4d5f0bc90b1cc99e40";

export default node;
